import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Collaboration = lazy(() => import('./Collaboration'))
const CollaborationMeeting = lazy(() => import('./CollaborationMeeting'))

const collaborationRoutes = [
  {
    path: '/collaboration',
    component: Collaboration,
    auth: authRoleAccess.collaboration_view,
  },
  {
    path: '/collaboration/meeting',
    component: CollaborationMeeting,
    auth: authRoleAccess.collaboration_view,
  },
  {
    path: '/collaboration/meeting/:roomId',
    component: CollaborationMeeting,
    auth: authRoleAccess.collaboration_view,
  },
]

export default collaborationRoutes
